import Vue from 'vue';
import Vuex from 'vuex';
import {
  AppMod,
  UserMod,
  ServiceMod,
  DeploymentMod,
  TranslationMod
} from '@/store/modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    AppMod,
    UserMod,
    ServiceMod,
    DeploymentMod,
    TranslationMod
  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
